<script>
import lazyLoadComponent from '@router/lazyload-component'
import { orderPaymentMethodFilter, bookingStatusFilter, paymentStatusMapFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import pageMixin from '@src/mixins/pagination'
import helperMixin from '@/src/mixins/helperMixin'
import reservationOrderDetailParentMixin from '@/src/mixins/reservationOrderDetailParentMixin'
export default {
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    ReservationOrderDetail: () => lazyLoadComponent(import('@components/Orders/ReservationOrderDetail')),
  },
  filters: {
    orderPaymentMethodFilter,
    formatDate,
    bookingStatusFilter,
    paymentStatusMapFilter,
  },
  mixins: [pageMixin, helperMixin, reservationOrderDetailParentMixin],
  props: {
    petValue: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    //  在寵物底下看要有返回鍵
    isPetSite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentKey: 0,
      loadedOrders: [],
      drawerVisible: false,
      drawerOrderData: {},
      loadingList: false,
      tryingToGetOrder: false,
      filterData: {
        order_by: 'created_at',
        order: 'desc',
      },
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
    }
  },
  watch: {
    currentPage: {
      handler: 'tryToSearchOrder',
      immediate: true,
    },
  },
  methods: {
    calcRowClassName({ row }) {
      console.log(row)
      const orderStatus = row.status
      const orderUsedStatus = row.groupSize / row.usedSize

      if (orderStatus === 0) return 'order--canceled'
      if (orderUsedStatus === 1) return 'order--used'
    },
    async tryToGetOrder(row) {
      this.tryingToGetOrder = true
      let newDrawerOrderData = await this.$store.dispatch('order/fetchSingle', row.id)
      this.drawerOrderData = this.initSpaceHelpers(Object.assign({}, this.initHelpers(Object.assign({}, newDrawerOrderData))))
      this.loadingList = false
      this.drawerVisible = true
      this.tryingToGetOrder = false
    },
    async tryToSearchOrder() {
      this.loadingList = true
      const { items, total } = await this.$store.dispatch(
        'order/fetchList',
        Object.assign(
          {
            memberId: this.$route.params.memberId,
            paymentMethod: 'All',
            order_by: this.filterData.order_by,
            order: this.filterData.order,
            petId: this.petValue,
            types: ['cosmetic', 'goods'],
          },
          this.pageQuery
        )
      )
      this.loadedOrders = items
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
      this.loadingList = false
    },
    sortChange({ column, prop, order }) {
      if (order) {
        this.filterData.order_by = prop
        this.filterData.order = order === 'ascending' ? 'asc' : 'desc'
        this.currentPage = 1
        this.tryToSearchOrder()
      }
      // console.log(column, prop, order)
    },
    backToList() {
      this.$emit('back')
    },
    /**
     * @description 關閉此編輯drawer後，重新fetch資料
     */
    async onEditOrderDone() {
      await this.tryToSearchOrder()
      this.$refs.orderFormEdit.closeDrawer()
      this.drawerVisible = false
    },
    getOrderType(order) {
      const typeMap = {
        goods: '商品',
        cosmetic: '服務',
      }

      const type = typeMap[order.params[0].type] || ''
      return `${type}訂單`
    },
  },
  computed: {
    drawerOrderType() {
      if (Object.keys(this.drawerOrderData).length) {
        return this.drawerOrderData.params[0].type === 'cosmetic' ? 'reservation' : this.drawerOrderData.params[0].type
      }
    },
  },
}
</script>

<template>
  <div v-loading.fullscreen.lock="tryingToGetOrder" element-loading-text="取得訂單資訊中">
    <BasePageHeader>
      <template v-slot:title>
        <el-button v-if="!!petValue" class="is-round isStyleBase mr-4" @click="backToList">
          <BaseIcon name="arrow-left" />
          返回
        </el-button>
        <span style="vertical-align: middle;">美容訂單</span>
      </template>
      <template v-if="!!petValue" v-slot:right>
        <span> {{ $t('reserve.CLIENT') }}：{{ defaultValue.name }} </span>
      </template>
    </BasePageHeader>
    <div class="bg-white">
      <div class="el-table-wrapper">
        <el-table
          v-loading.lock="loadingList"
          class="isBgDark"
          element-loading-background="rgba(255, 255, 255, 0.6)"
          :data="loadedOrders"
          :default-sort="{ prop: 'created', order: 'descending' }"
          :row-class-name="calcRowClassName"
          @row-click="tryToGetOrder"
          @sort-change="sortChange"
        >
          <el-table-column v-slot="{ row }" prop="created_at" min-width="160" label="訂單類型 / 編號" sortable="custom">
            <div class="Jost">
              <span class="text-secondary-light fs-sm">{{ getOrderType(row) }}</span
              ><br />
              #{{ row.id }} <br />
              <span class="text-secondary-light fs-sm">{{ row.created | formatDate }} {{ row.created | formatDate('time') }}</span>
            </div>
          </el-table-column>
          <el-table-column v-slot="{ row }" prop="status" min-width="130" label="訂單狀態" sortable="custom">
            <BaseStateLabel :state="row.paymentStatus | paymentStatusMapFilter('color')" text
              >{{ row.paymentStatus | paymentStatusMapFilter('text') }}<span v-if="row.cancelAt !== null && row.cancelAt.length > 0" style="color: #2D385F">(已取消)</span>
            </BaseStateLabel>
            <br />
            <BaseStateLabel class="text-secondary-light fs-sm" text>{{ row.paymentMethod | orderPaymentMethodFilter }} </BaseStateLabel>
            <!-- <BaseStateLabel state="info" text>{{ row.source | orderSourceFilter }}</BaseStateLabel> -->
          </el-table-column>
          <el-table-column v-if="$merchantI18n() === 'pet'" v-slot="{ row }" min-width="70" label="預約狀態">
            <BaseStateLabel state="info" text>{{ row.status | bookingStatusFilter('text') }}</BaseStateLabel>
          </el-table-column>
          <el-table-column v-if="!petValue && $merchantI18n() === 'pet'" v-slot="{ row }" min-width="70" :label="`${$t('reserve.CLIENT')}`">
            <div v-if="!petValue">{{ row.pet.name }}</div>
          </el-table-column>
          <el-table-column v-slot="{ row }" prop="startDate" min-width="200" label="項目 / 時間" sortable="custom">
            <div>{{ row.productName }} {{ row.params[0].title }}</div>
            <div class="text-secondary-light fs-sm">{{ row.date | formatDate }} {{ row.time }}</div>
            <div class="Jost text-secondary-light fs-sm">${{ row.allActualPayTotal }}</div>
          </el-table-column>

          <el-table-column min-width="40">
            <el-tooltip content="查看訂單詳情" placement="top">
              <el-button type="text">
                <BaseIcon name="ellipsis-v" />
              </el-button>
            </el-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <BasePagination ref="pagination" :current-page.sync="currentPage" />
    </div>
    <el-drawer
      ref="orderFormEdit"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="drawerVisible"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      :show-close="closeBtnShowStatus"
      :wrapper-closable="false"
      append-to-body
      destroy-on-close
      custom-class="order-drawer"
    >
      <ReservationOrderDetail
        ref="orderDetail"
        :order-type="drawerOrderType"
        :default-value.sync="drawerOrderData"
        @closeBtnShowFunc="closeBtnShowFunc"
        @update="tryToSearchOrder"
        @store="onEditOrderDone"
        @onlyFetchSingleOrder="onlyFetchSingleOrder"
      />
    </el-drawer>
  </div>
</template>
